export type ProfileConflict = "override" | "skip" | "error";

export interface ProfileConflictOption {
  value: ProfileConflict;
  label: string;
  hint: string;
}

export const DEFAULT_PROFILE_CONFLICT: ProfileConflict = "error";

const OPTIONS: ProfileConflictOption[] = [
  {
    value: "override",
    label: "Replace the current agent",
    hint: "The ticket goes through and the profile moves to the agent taking it.",
  },
  {
    value: "skip",
    label: "Skip that ticket, silently",
    hint: "The ticket and the profile both stay as they are. No warning.",
  },
  {
    value: "error",
    label: "Skip that ticket, and report it",
    hint: "The ticket and the profile both stay as they are. The error is listed for you.",
  },
];

export const profileConflictOptions = (
  values: ProfileConflict[] = OPTIONS.map((option) => option.value),
): ProfileConflictOption[] =>
  values
    .map((value) => OPTIONS.find((option) => option.value === value))
    .filter((option): option is ProfileConflictOption => Boolean(option));
